import type { AuthError } from '@kmgestao/supabase-client';

/**
 * Traduz erros do Supabase Auth para **chaves i18n** pt-BR (namespace `auth`
 * ou `common`), resolvidas no componente via `t()` do react-i18next.
 * Retornar chave (e não string crua) preserva a regra §5.3 do CLAUDE.md.
 *
 * Referência dos códigos: https://supabase.com/docs/reference/javascript/auth-api
 */
export function mapAuthErrorKey(error: AuthError | Error | null | undefined): string {
  if (!error) return 'common:errors.unknown';
  const message = ('message' in error ? error.message : '').toLowerCase();

  if (message.includes('invalid login credentials')) return 'auth:errors.invalidCredentials';
  if (message.includes('email not confirmed')) return 'auth:errors.emailNotConfirmed';
  if (message.includes('invalid email')) return 'auth:errors.invalidEmail';
  if (message.includes('user already registered')) return 'auth:errors.userAlreadyRegistered';
  if (message.includes('password should be')) return 'auth:errors.passwordTooWeak';
  if (message.includes('same password')) return 'auth:errors.samePassword';
  if (message.includes('rate limit') || message.includes('too many'))
    return 'auth:errors.rateLimit';
  if (message.includes('captcha')) return 'auth:errors.captchaFailed';
  if (message.includes('network') || message.includes('fetch')) return 'common:errors.network';
  if (message.includes('token') && message.includes('expired')) return 'auth:errors.linkExpired';

  return 'common:errors.generic';
}
